"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Speech_instances, _Speech_serviceProvider, _Speech_elements, _Speech_present, _Speech_validateDuration, _Speech_notEmpty, _Speech_isFunction;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Speech = exports.escapeSSML = void 0;
const serviceTypes_1 = require("./serviceTypes");
const actionsPerProvider = {
    [serviceTypes_1.ServiceProvider.POLLY]: new Set(["say", "pause", "prosody", "toObject", "ssml", "sayWithSSML"]),
    [serviceTypes_1.ServiceProvider.POLLY_NEURAL]: new Set(["say", "pause", "prosody", "toObject", "ssml", "sayWithSSML"]),
    [serviceTypes_1.ServiceProvider.GOOGLE]: new Set(["say", "pause", "prosody", "toObject", "ssml", "sayWithSSML"]),
    [serviceTypes_1.ServiceProvider.WELLSAID]: new Set([]),
    [serviceTypes_1.ServiceProvider.ELEVENLABS]: new Set(["say", "pause", "toObject", "ssml", "sayWithSSML"]),
    [serviceTypes_1.ServiceProvider.TAVUS]: new Set(["say", "pause", "toObject", "ssml", "sayWithSSML"]),
    [serviceTypes_1.ServiceProvider.DUMMY]: new Set([])
};
const roundTwoDigits = (ratio) => {
    return Math.round(ratio * 100) / 100;
};
/**
 * This method escapes any special characters that will cause SSML to be invalid.
 * @param text being the text to insert
 * @returns {*}
 * @private
 */
const escapeSSML = (text) => {
    if (typeof (text) === "string") {
        text = text.replace(/&/g, "&amp;");
        text = text.replace(/</g, "&lt;");
        text = text.replace(/>/g, "&gt;");
        text = text.replace(/"/g, "&quot;");
        text = text.replace(/'/g, "&apos;");
        return text;
    }
    if (typeof (text) === "number") {
        return text.toString();
    }
    if (typeof (text) === "boolean") {
        return text.toString();
    }
    throw new Error("received invalid type " + typeof (text));
};
exports.escapeSSML = escapeSSML;
/**
 * This class was migrated from ssml-builder:
 * https://www.npmjs.com/package/ssml-builder
 *
 * This class is for internal use of the narration-service. User should know what's supported or not
 */
class Speech {
    constructor(serviceProvider) {
        _Speech_instances.add(this);
        _Speech_serviceProvider.set(this, void 0);
        _Speech_elements.set(this, []);
        __classPrivateFieldSet(this, _Speech_serviceProvider, serviceProvider, "f");
    }
    /**
     * This appends raw text into the <speak/> tag.
     * @param saying The raw text to insert into the speak tag.
     * @returns {Speech}
     */
    say(saying) {
        this.validateAction("say");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, saying, "The saying provided to Speech#saying(..) was null or undefined.");
        __classPrivateFieldGet(this, _Speech_elements, "f").push((0, exports.escapeSSML)(saying));
        return this;
    }
    /**
     * Creates and inserts a paragraph tag.
     * see https://developer.amazon.com/public/solutions/alexa/alexa-skills-kit/docs/speech-synthesis-markup-language-ssml-reference#p
     * @param paragraph The paragraph of text to insert.
     * @returns {Speech}
     */
    paragraph(paragraph) {
        this.validateAction("paragraph");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, paragraph, "The paragraph provided to Speech#paragraph(..) was null or undefined.");
        __classPrivateFieldGet(this, _Speech_elements, "f").push(`<p>${(0, exports.escapeSSML)(paragraph)}</p>`);
        return this;
    }
    /**
     * Creates and inserts a sentence tag.
     * see https://developer.amazon.com/public/solutions/alexa/alexa-skills-kit/docs/speech-synthesis-markup-language-ssml-reference#s
     * @param saying The sentence to insert.
     * @returns {Speech}
     */
    sentence(saying) {
        this.validateAction("sentence");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, saying, "The sentence provided to Speech#sentence(..) was null or undefined.");
        __classPrivateFieldGet(this, _Speech_elements, "f").push(`<s>${(0, exports.escapeSSML)(saying)}</s>`);
        return this;
    }
    /**
     * Creates and inserts a break tag. This method will also validate the break time conforms to the restrictions to Amazon Alexa.
     * see https://developer.amazon.com/public/solutions/alexa/alexa-skills-kit/docs/speech-synthesis-markup-language-ssml-reference#break
     * @param duration the duration represented by a number + either "s" for second or "ms" for milliseconds.
     * @returns {Speech}
     */
    pause(duration) {
        this.validateAction("pause");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, duration, "The duration provided to Speech#pause(..) was null or undefined.");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_validateDuration).call(this, duration);
        __classPrivateFieldGet(this, _Speech_elements, "f").push(`<break time="${duration}"/>`);
        return this;
    }
    /**
     * Creates a break tag that will pause the audio based upon the strength provided.
     * For more information, please see https://developer.amazon.com/public/solutions/alexa/alexa-skills-kit/docs/speech-synthesis-markup-language-ssml-reference#break
     * @param strength such as none, x-weak, weak, medium, strong, x-strong
     * @returns {Speech}
     */
    pauseByStrength(strength) {
        this.validateAction("pauseByStrength");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, strength, "The strength provided to Speech#pauseByStrength(..) was null or undefined");
        strength = strength.toLowerCase().trim();
        const strengths = ["none", "x-weak", "weak", "medium", "strong", "x-strong"];
        isInList(strength, strengths, "The strength provided to Speech#pauseByStrength(..) was not valid. Received strength: " + strength);
        __classPrivateFieldGet(this, _Speech_elements, "f").push(`<break strength="${strength}"/>`);
        return this;
    }
    /**
     * Creates and inserts an audio tag.
     * see https://developer.amazon.com/public/solutions/alexa/alexa-skills-kit/docs/speech-synthesis-markup-language-ssml-reference#audio
     * @param url a link to an audio file to play.
     * @param callback - an optional callback which is called to build the nested SSML
     *                   for the audio tag. The callback takes a single parameter of type
     *                   Speech.
     * @returns {Speech}
     */
    audio(url, callback) {
        this.validateAction("audio");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, url, "The url provided to Speech#audio(..) was null or undefined.");
        if (callback) {
            __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_isFunction).call(this, callback, "callback");
            const audioBuilder = new Speech(__classPrivateFieldGet(this, _Speech_serviceProvider, "f"));
            callback(audioBuilder);
            __classPrivateFieldGet(this, _Speech_elements, "f").push(`<audio src="${url}">${audioBuilder.ssml(true)}</audio>`);
        }
        else {
            __classPrivateFieldGet(this, _Speech_elements, "f").push(`<audio src="${url}"/>`);
        }
        return this;
    }
    /**
     * Creates and inserts a say-as tag.
     * see https://developer.amazon.com/public/solutions/alexa/alexa-skills-kit/docs/speech-synthesis-markup-language-ssml-reference#say-as
     * @param word word or text to insert
     * @returns {Speech}
     */
    spell(word) {
        this.validateAction("spell");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, word, "The word provided to Speech#spell(..) was null or undefined.");
        __classPrivateFieldGet(this, _Speech_elements, "f").push(`<say-as interpret-as="spell-out">${(0, exports.escapeSSML)(word)}</say-as>`);
        return this;
    }
    /**
     * Creates and inserts a say-as tag.
     * see https://developer.amazon.com/public/solutions/alexa/alexa-skills-kit/docs/speech-synthesis-markup-language-ssml-reference#say-as
     * @param word word or text to insert
     * @param delay the delay represented by a number + either "s" for second or "ms" for milliseconds.
     * @returns {Speech}
     */
    spellSlowly(word, delay) {
        this.validateAction("spellSlowly");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, word, "The word provided to Speech#spellSlowly(..) was null or undefined.");
        for (let i = 0; i < word.length; i++) {
            __classPrivateFieldGet(this, _Speech_elements, "f").push(`<say-as interpret-as="spell-out">${(0, exports.escapeSSML)(word.charAt(i))}</say-as>`);
            this.pause(delay);
        }
        return this;
    }
    /**
     * This constructs an object that the AlexaSkill.js accepts to send to the user.
     * @returns {{type: string, speech}}
     */
    toObject() {
        this.validateAction("toObject");
        return {
            type: "SSML",
            speech: this.ssml()
        };
    }
    /**
     * This method will construct an SSML xml string.
     * @param excludeSpeakTag when true, no root tag <speak/> is provided; otherwise,
     *        the content is surrounded by the <speak/>, default is false
     * @returns {string} An XML string.
     */
    ssml(excludeSpeakTag) {
        // todo - excludeSpeakTag should be by provider
        this.validateAction("ssml");
        if (excludeSpeakTag) {
            return __classPrivateFieldGet(this, _Speech_elements, "f").join(" ");
        }
        return `<speak>${__classPrivateFieldGet(this, _Speech_elements, "f").join(" ")}</speak>`;
    }
    /**
     * Creates and inserts a say-as tag that has multiple attributes such as interpret-as and format
     * interpret-as="characters|spell-out|cardinal|number|ordinal|digits|fraction|unit|date|time|telephone|address|interjection|expletive" + format="mdy|dmy|ymd|md|dm|ym|my|d|m|y"
     *
     * see https://developer.amazon.com/public/solutions/alexa/alexa-skills-kit/docs/speech-synthesis-markup-language-ssml-reference#say-as
     * @param options an object that has three properties: word, interpret and format
     * word being the text to insert, interpret represents the attribute interpret-as and format represents the attribute format
     * @returns {Speech}
     */
    sayAs(options) {
        this.validateAction("sayAs");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, options, "The object provided to Speech#sayAs(..) was invalid.");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, options.word, "The word provided to Speech#sayAs(..) was null or undefined.");
        if (options.interpret) {
            const listOfInterpret = ["characters", "spell-out", "cardinal", "number", "ordinal", "digits", "fraction", "unit", "date", "time", "telephone", "address", "interjection", "expletive"];
            isInList(options.interpret, listOfInterpret, "The interpret is invalid. Received this: " + options.interpret);
            if (options.format) {
                __classPrivateFieldGet(this, _Speech_elements, "f").push(`<say-as interpret-as="${options.interpret}" format="${options.format}">${options.word}</say-as>`);
                return this;
            }
            __classPrivateFieldGet(this, _Speech_elements, "f").push(`<say-as interpret-as="${options.interpret}">${options.word}</say-as>`);
            return this;
        }
        else {
            __classPrivateFieldGet(this, _Speech_elements, "f").push(options.word);
            return this;
        }
    }
    /**
     * Creates and inserts a w tag that customizes the pronunciation of words by specifying the word’s part of speech
     * see https://developer.amazon.com/public/solutions/alexa/alexa-skills-kit/docs/speech-synthesis-markup-language-ssml-reference#w
     * @param options an object that has two properties: word and role
     * word being the text to insert and role represents the part of speech
     * @returns {Speech}
     */
    partOfSpeech(options) {
        this.validateAction("partOfSpeech");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, options, "The object provided to Speech#partOfSpeech(..) was invalid.");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, options.word, "The word provided to Speech#partOfSpeech(..) was null or undefined.");
        const word = (0, exports.escapeSSML)(options.word);
        if (options.role) {
            __classPrivateFieldGet(this, _Speech_elements, "f").push(`<w role="${options.role}">${word}</w>`);
        }
        return this;
    }
    /**
     * Creates and inserts a phoneme tag.
     * see https://developer.amazon.com/public/solutions/alexa/alexa-skills-kit/docs/speech-synthesis-markup-language-ssml-reference#phoneme
     * @param alphabet i.e "ipa"
     * @param ph i.e "pɪˈkɑːn"
     * @param word being the text to insert
     * @returns {Speech}
     */
    phoneme(alphabet, ph, word) {
        this.validateAction("phoneme");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, alphabet, "The alphabet provided to Speech#phoneme(..) was null or undefined.");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, ph, "The ph provided to Speech#phoneme(..) was null or undefined.");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, word, "The word provided to Speech#phoneme(..) was null or undefined.");
        const escapedWord = (0, exports.escapeSSML)(word);
        if (ph.indexOf("'") !== -1) {
            ph = ph.replace(/'/g, "&apos;");
        }
        __classPrivateFieldGet(this, _Speech_elements, "f").push(`<phoneme alphabet="${alphabet}" ph="${ph}">${escapedWord}</phoneme>`);
        return this;
    }
    /**
     * Creates and inserts a emphasis tag.
     * see https://developer.amazon.com/public/solutions/alexa/alexa-skills-kit/docs/speech-synthesis-markup-language-ssml-reference#emphasis
     * @param level includes strong, moderate and reduced
     * @param word word or text to insert
     * @returns {Speech}
     */
    emphasis(level, word) {
        this.validateAction("emphasis");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, level, "The level provided to Speech#emphasis(..) was null or undefined");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, word, "The word provided to Speech#emphasis(..) was null or undefined");
        const levels = ["strong", "moderate", "reduced"];
        if (levels.indexOf(level) < 0) {
            throw new Error("The level provided to Speech#emphasis(..) was not valid. Received level: " + level);
        }
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_notEmpty).call(this, word, "The word provided to Speech#emphasis(..) was empty");
        __classPrivateFieldGet(this, _Speech_elements, "f").push(`<emphasis level="${level}">${(0, exports.escapeSSML)(word)}</emphasis>`);
        return this;
    }
    /**
     * √ TODO: Handle rate minimum 20%
     * @param attributes
     * @param word
     * @param escapeWord default is true, should the word be escaped. This allows adding raw SSML.
     * @returns {Speech}
     */
    prosody(attributes, word, escapeWord = true) {
        this.validateAction("prosody");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, attributes, "The attributes provided to Speech#prosody(..) was null or undefined");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, word, "The word provided to Speech#prosody(..) was null or undefined");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_notEmpty).call(this, word, "The word provided to Speech#prosody(..) was empty");
        const validRates = ["x-slow", "slow", "medium", "fast", "x-fast"];
        const validPitches = ["x-low", "low", "medium", "high", "x-high"];
        const validVolumes = ["silent", "x-soft", "soft", "medium", "loud", "x-loud"];
        let final = "<prosody";
        validateAttribute(attributes, "rate", validRates, function () {
            let ratePercent;
            const parseAsNumber = Number(attributes.rate);
            if (!isNaN(parseAsNumber)) {
                // assume 1 is 100% and parseAsNumber is already rounded to 2 decimal places
                ratePercent = parseAsNumber * 100;
            }
            else if (/\d+%/.test(attributes.rate)) {
                // Assume number with percentage
                const numString = attributes.rate.substring(0, attributes.rate.length - 1);
                ratePercent = parseInt(numString);
            }
            if (!ratePercent) {
                throw new Error(`attributes.rate "${attributes.rate}" is not a valid rate input`);
            }
            checkRateRange(ratePercent);
            attributes.rate = `${ratePercent}%`;
        }, function () {
            final += ` rate="${attributes.rate}"`;
        });
        validateAttribute(attributes, "pitch", validPitches, function () {
            if (!/(\+|-)\d+(\.\d+)?%/.test(attributes.pitch)) {
                throw new Error("attributes.pitch is not a valid pitch");
            }
        }, function () {
            final += ` pitch="${attributes.pitch}"`;
        });
        validateAttribute(attributes, "volume", validVolumes, function () {
            let volumeDb;
            const parseAsNumber = Number(attributes.volume);
            if (!isNaN(parseAsNumber)) {
                // 0.2 <= volume <= 5
                const limitedVolume = Math.min(5, Math.max(0.2, parseAsNumber));
                // Round to 0.01 precision
                const volumeDbNum = roundTwoDigits(20 * Math.log10(limitedVolume));
                volumeDb = `${volumeDbNum > 0 ? "+" : ""}${volumeDbNum}dB`;
            }
            else if (/(\+|-)\d+(\.\d+)?db/.test(attributes.volume)) {
                volumeDb = attributes.volume;
            }
            if (!volumeDb) {
                throw new Error(`attributes.volume "${attributes.volume}" is not a valid volume input`);
            }
            attributes.volume = volumeDb;
        }, function () {
            final += ` volume="${attributes.volume}"`;
        });
        if (escapeWord) {
            final += `>${(0, exports.escapeSSML)(word)}</prosody>`;
        }
        else {
            final += `>${word}</prosody>`;
        }
        __classPrivateFieldGet(this, _Speech_elements, "f").push(final);
        return this;
    }
    /**
     * This method lets the user provide an alias and pronounce the specified word or phrase as a different word or phrase
     * @param alias is the word that you want to pronounce instead of the original word
     * @param word
     * @returns {Speech}
     */
    sub(alias, word) {
        this.validateAction("sub");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, alias, "The alias provided to Speech#sub(..) was null or undefined");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_notEmpty).call(this, alias, "The alias provided to Speech#sub(..) was empty");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, word, "The word provided to Speech#sub(..) was null or undefined");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_notEmpty).call(this, word, "The word provided to Speech#sub(..) was empty");
        __classPrivateFieldGet(this, _Speech_elements, "f").push(`<sub alias="${alias}">${(0, exports.escapeSSML)(word)}</sub>`);
        return this;
    }
    /**
     * This method lets the user add raw SSML into the speech object without escaping the special characters.
     * For example, if you passed in "<speak>Hi</speak>", it won't escape the less than or greater than tags.
     * @param saying raw string to be appended
     * @returns {Speech}
     */
    sayWithSSML(saying) {
        this.validateAction("sayWithSSML");
        __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, saying, "The saying provided to Speech#sayWithSSML(..) was null or undefined.");
        __classPrivateFieldGet(this, _Speech_elements, "f").push(saying);
        return this;
    }
    // Private methods //
    /**
     * This method validates that the action is supported by the provider.
     * @param action
     */
    validateAction(action) {
        if (!actionsPerProvider[__classPrivateFieldGet(this, _Speech_serviceProvider, "f")].has(action)) {
            throw new Error(`Action ${action} is not supported for provider ${__classPrivateFieldGet(this, _Speech_serviceProvider, "f")}`);
        }
    }
}
exports.Speech = Speech;
_Speech_serviceProvider = new WeakMap(), _Speech_elements = new WeakMap(), _Speech_instances = new WeakSet(), _Speech_present = function _Speech_present(value, msg) {
    if (value === null || value === undefined) {
        throw msg;
    }
}, _Speech_validateDuration = function _Speech_validateDuration(duration) {
    const re = /^(\d*\.?\d+)(s|ms)$/;
    if (duration.match(re)) {
        const parts = re.exec(duration);
        const pauseDuration = Number(parts[1]);
        const pauseType = parts[2];
        if (pauseType.toLowerCase() === "s" && pauseDuration > 10) {
            throw "The pause duration exceeds the allowed 10 second duration. Duration provided: " + duration;
        }
        else if (pauseDuration > 10000) {
            throw "The pause duration exceeds the allowed 10,000 milliseconds duration. Duration provided: " + duration;
        }
    }
    else {
        throw "The duration must be a number followed by either \"s\" for second or \"ms\" for milliseconds. e.g., 10s or 100ms. Max duration is 10 seconds (10000 milliseconds).";
    }
}, _Speech_notEmpty = function _Speech_notEmpty(word, msg) {
    __classPrivateFieldGet(this, _Speech_instances, "m", _Speech_present).call(this, word, msg);
    if (word.length === 0) {
        throw msg;
    }
}, _Speech_isFunction = function _Speech_isFunction(fnc, name) {
    const fncType = typeof (fnc);
    if (fncType !== "function") {
        throw new Error(name + " was not a function. received: " + fncType);
    }
};
/**
 * This helper function consolidates the validation checks for rate,pitch and volume. It will first
 * check to see if the attribute is present and whether it's one of the following conditions:
 *  a) the value of the attribute is a valid value or
 *  b) the value does not exist in the list, but passes the onCheck function. A hook for additional checks.
 *
 *  Upon passing the above checks, the onSuccessful function is called allowing the caller to do any additional work.
 *
 * @param obj The object that owns the attribute.
 * @param attribute The attribute name to check. e.g., rate, pitch or volume.
 * @param validList The list of value values that the attribute can be.
 * @param onCheck A hook for additional checks if the value does not exist in the list.
 * @param onSuccessful A hook to call when all validation checks succeed.
 */
function validateAttribute(obj, attribute, validList, onCheck, onSuccessful) {
    if (obj === null || obj === void 0 ? void 0 : obj[attribute]) {
        obj[attribute] = obj[attribute].toLowerCase().trim();
        if (validList.indexOf(obj[attribute]) == -1) {
            onCheck();
        }
        onSuccessful();
    }
}
/**
 * This method ensures that the value of the rate must be equal or great than 20%
 * @param num is the value of rate
 */
function checkRateRange(num) {
    if (num < 20) {
        throw new Error("The minimum rate is twenty percentage. Received: " + num);
    }
}
/**
 * This method validates if the value exists in the list of values
 * @param value
 * @param listOfValues
 * @param msg is the error message that will be thrown when the value is not in the list
 */
function isInList(value, listOfValues, msg) {
    value = value.toLowerCase().trim();
    if (listOfValues.indexOf(value) === -1) {
        throw new Error(msg);
    }
}
//# sourceMappingURL=ssml.js.map